import type { CachedPaymentIntent } from '../interfaces/paymentInit.interface';
import {
  PAYMENT_INTENT_ASSUMED_LIFETIME_MS,
  PAYMENT_INTENT_MIN_LIFETIME_MS,
} from '../common/constants/paymentInit';

export function isPaymentIntentUsable(
  cached: CachedPaymentIntent,
  amount: number,
  nowMs: number,
): boolean {
  if (cached.amount === null || cached.amount !== amount) return false;

  if (cached.expiresAt === undefined || cached.expiresAt === null) {
    return cached.fetchedAtMs !== undefined
      && nowMs - cached.fetchedAtMs < PAYMENT_INTENT_ASSUMED_LIFETIME_MS;
  }

  return cached.expiresAt * 1000 - nowMs > PAYMENT_INTENT_MIN_LIFETIME_MS;
}
